import React from "react";
import {useDispatch, useSelector} from "react-redux";
import {Switch, FormControlLabel} from "@material-ui/core";
import styled from "styled-components";
import {toggleDarkMode} from "../features/sliceReducer/themeSlice";
import {AppDispatch} from "../features/store/store";
import {RootState} from "../features/store";
import {Brightness3, WbSunny} from "@material-ui/icons";

const StyledSwitch = styled(Switch)`
  & .MuiSwitch-thumb {
    background-color: "red";
  }
  & .Mui-checked .MuiSwitch-thumb {
    background-color: "blue";
  }
`;

const ThemeSwitch: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const darkMode = useSelector((state: RootState) => state.theme.darkMode);

  const handleToggle = () => {
    dispatch(toggleDarkMode());
  };

  return (
    <FormControlLabel
      control={
        <StyledSwitch
          color="primary"
          checked={darkMode}
          onChange={handleToggle}
          name="darkModeToggle"
        />
      }
      label={darkMode ? <Brightness3 /> : <WbSunny />}
      labelPlacement="start"
      style={{
        display: "flex",
        alignItems: "center",
        marginRight: "20px",
        color: darkMode ? "white" : "black",
      }}
    />
  );
};

export default ThemeSwitch;
